import type { AvatarInfo } from './models'
import { AvatarSize } from './models'
import { environment } from '../../environments'

const getAvatarURLByUserKey =
  (userKey: string) =>
  (avatarSize: AvatarSize = AvatarSize.SMALL) =>
    `${environment().avatarBaseUrl}/${userKey}_${avatarSize}.jpg`
const getAvatarURLByEmail =
  (emailAddress: string) =>
  (avatarSize: AvatarSize = AvatarSize.SMALL) =>
    `${environment().avatarBaseUrl}/emails/${emailAddress}/${avatarSize}.jpg`

export async function getAvatarUrls(userKey: string, emailAddress?: string): Promise<AvatarInfo>
export async function getAvatarUrls(userKey: undefined, emailAddress: string): Promise<AvatarInfo>

export async function getAvatarUrls(userKey: unknown, emailAddress: unknown): Promise<AvatarInfo> {
  const cacheBuster = Date.now()

  let formatURL: ReturnType<typeof getAvatarURLByEmail | typeof getAvatarURLByUserKey>
  if (typeof userKey === 'string' && userKey !== '') {
    formatURL = getAvatarURLByUserKey(userKey)
  } else if (typeof emailAddress === 'string' && emailAddress !== '') {
    formatURL = getAvatarURLByEmail(emailAddress)
  } else {
    throw new Error('Cannot get avatar without a user key or email address')
  }

  const { headers } = await fetch(`${formatURL()}?cacheBuster=${cacheBuster}`, {
    method: 'HEAD',
    cache: 'no-store',
  })

  return {
    isDefault: headers.get('x-amz-meta-type') === 'default',
    urlSmall: formatURL(AvatarSize.SMALL),
    urlMedium: formatURL(AvatarSize.MEDIUM),
    urlLarge: formatURL(AvatarSize.LARGE),
    urlXLarge: formatURL(AvatarSize.X_LARGE),
  }
}
